import _Loading2 from "element-ui/lib/theme-chalk/loading.css";
import "element-ui/lib/theme-chalk/base.css";
import _Loading from "element-ui/lib/loading";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getVideoUrl, playOrPauseVideo } from '@/utils/guide-video.js';
import ExperienceGuideDialog from './experience-guide-dialog.vue';
import CourseOutline from './course-outline.vue';
import XdfPagination from './xdf-pagination.vue';
import { getFirstGuide } from '@/api/modules/guide.js';
export default {
  name: 'LeftContent',
  components: {
    ExperienceGuideDialog: ExperienceGuideDialog,
    CourseOutline: CourseOutline,
    XdfPagination: XdfPagination
  },
  props: {
    menuVisible: {
      type: Boolean,
      default: true
    },
    preciousType: {
      type: Number,
      default: 1
    },
    boxInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    expandExperience: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      pageSet: {
        pageNum: null,
        total: 0
      },
      videoUrl: '',
      isFirstExperience: false,
      isFullScreen: false,
      loading: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['experienceInfos', // 错题本页面返回后需要记住的
  'closeCodeDialog'])), {}, {
    imgUrl: function imgUrl() {
      var _tempInfo$filter$,
          _this = this;

      var tempInfo = this.pageSet.pageNum < 1 ? this.boxInfo.boxCoverInfo : this.boxInfo.boxContentInfo;
      return tempInfo === null || tempInfo === void 0 ? void 0 : (_tempInfo$filter$ = tempInfo.filter(function (item) {
        return item.page === _this.pageSet.pageNum;
      })[0]) === null || _tempInfo$filter$ === void 0 ? void 0 : _tempInfo$filter$.url;
    },
    pageObj: function pageObj() {
      var _this$boxInfo$boxCove, _this$boxInfo$boxCont;

      // 页码需要的数据
      return {
        cover: (_this$boxInfo$boxCove = this.boxInfo.boxCoverInfo) === null || _this$boxInfo$boxCove === void 0 ? void 0 : _this$boxInfo$boxCove.map(function (item) {
          return item.page;
        }),
        content: (_this$boxInfo$boxCont = this.boxInfo.boxContentInfo) === null || _this$boxInfo$boxCont === void 0 ? void 0 : _this$boxInfo$boxCont.map(function (item) {
          return item.page;
        })
      };
    }
  }),
  watch: {
    boxInfo: {
      handler: function handler(val) {
        var _val$boxCoverInfo$0$p, _val$boxCoverInfo, _val$boxCoverInfo$, _val$boxContentInfo;

        this.pageSet = {
          pageNum: (_val$boxCoverInfo$0$p = (_val$boxCoverInfo = val.boxCoverInfo) === null || _val$boxCoverInfo === void 0 ? void 0 : (_val$boxCoverInfo$ = _val$boxCoverInfo[0]) === null || _val$boxCoverInfo$ === void 0 ? void 0 : _val$boxCoverInfo$.page) !== null && _val$boxCoverInfo$0$p !== void 0 ? _val$boxCoverInfo$0$p : 1,
          // 默认封面
          total: (_val$boxContentInfo = val.boxContentInfo) === null || _val$boxContentInfo === void 0 ? void 0 : _val$boxContentInfo.length
        }; // 传给右侧菜单

        this.emitRight();
      },
      immediate: true
    },
    // 页码的笔记关闭后启动视频继续播放
    closeCodeDialog: function closeCodeDialog(val) {
      if (val) {
        playOrPauseVideo('videoPlay');
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this2$$refs$studyImg;

      var _yield$getFirstGuide, tempData;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.showLoading(); // 初始化的值不一定


              _this2.experienceInfos.pageNum && (_this2.pageSet.pageNum = _this2.experienceInfos.pageNum);

              _this2.$store.dispatch('setExperienceInfos', {}); // 重置
              // 初始化传给右侧菜单


              _this2.emitRight(); // 接受智能学习的视频播放的事件


              _this2.$bus.$on('videoChange', _this2.handlerVideoUrl); // 首次进入引导逻辑


              _context.next = 7;
              return getFirstGuide({
                code: 'C0026'
              });

            case 7:
              _yield$getFirstGuide = _context.sent;
              tempData = _yield$getFirstGuide.data;
              _this2.isFirstExperience = !!tempData; // 图片加载监听

              (_this2$$refs$studyImg = _this2.$refs.studyImg) === null || _this2$$refs$studyImg === void 0 ? void 0 : _this2$$refs$studyImg.addEventListener('load', function () {
                _this2.loading.close();
              });
              window.addEventListener('message', _this2.listenMessage);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    var _this$$refs$studyImg,
        _this3 = this;

    this.$bus.$off('videoChange');
    (_this$$refs$studyImg = this.$refs.studyImg) === null || _this$$refs$studyImg === void 0 ? void 0 : _this$$refs$studyImg.removeEventListener('load', function () {
      _this3.loading.close();
    });
    window.addEventListener('message', this.listenMessage);
  },
  methods: {
    // 修改页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.$refs.leftMenu.$refs.wrap.scrollTo({
        top: 0
      });
      if (this.pageSet.pageNum === +val) return;
      this.showLoading();
      this.pageSet.pageNum = +val;
      this.emitRight();
    },
    handlerVideoUrl: function handlerVideoUrl(val) {
      var videoType = val.videoType,
          videoName = val.videoName,
          videoId = val.videoId;
      this.videoUrl = getVideoUrl({
        videoType: videoType,
        videoName: videoName,
        videoId: videoId
      });
    },
    showLoading: function showLoading() {
      this.loading = _Loading.service({
        fullscreen: true,
        background: 'transparent',
        text: '加载中…'
      });
    },
    emitRight: function emitRight() {
      var temp = this.pageSet.pageNum;
      this.$bus.$emit('toRightMenu', {
        preciousType: this.preciousType,
        pageNum: temp,
        isLastPage: temp === this.pageSet.total
      });
    },
    listenMessage: function listenMessage(_ref) {
      var data = _ref.data;

      if ((data === null || data === void 0 ? void 0 : data.eventName) === 'setFullScreen') {
        this.isFullScreen = data === null || data === void 0 ? void 0 : data.fullScreen;
      }
    }
  }
};